import { NavigationContext } from "navigation-react";
import React, { useContext } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faTachometerAlt,
//   faUserPlus,
//   faUsers,
//   faClipboardList,
//   faListAlt,
//   faUserCog,
// } from "@fortawesome/free-solid-svg-icons";
// import anihlogoimage from "./images/idclogo.png";
// import { NavigationContext, NavigationLink } from "navigation-react";
// import SecureLS from "secure-ls";

// const ls = new SecureLS({ encodingType: "aes" });
const EditUserProfile = () => {
  // const [loading, setLoading] = useState(false);
  // const { stateNavigator } = useContext(NavigationContext);
  const { data } = useContext(NavigationContext);
  // const userCSRFTOKENlogout = ls.get("userCSRFTOKENlogout");
  // const username = ls.get("username");
  // const sessionTokenData = ls.get("sessionToken");

  // const handleLogout = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await fetch(
  //       `/user/logout?_format=json&token=${userCSRFTOKENlogout}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     if (response.ok) {
  //       console.log("Logout successful");
  //       ls.clear();
  //       stateNavigator.navigate("login");
  //     }
  //   } catch (error) {
  //     console.error("Error during logout:", error);
  //   }
  // };

  return (
    <div className="userprofile-container">
      <h2>Edit user profile {data.userdata}</h2>
    </div>
  );
};

export default EditUserProfile;
